<template>
<!-- <Navbar/> -->
<!-- <SideBar/> -->
 
<div class="card main-content">
        <div class="progress-spinner" v-if="spinnerLoadingStatus">
            <ProgressSpinner></ProgressSpinner>
        </div>
        <div >
          <Card class="mb-3 mx-3 mt-3">
            <template #title>Custom Filter</template>
            <template #content>
              <div class="formgrid grid">
                <div class="field col">
                  <strong><label for="firstname2">Given Status:</label></strong>
                  <Dropdown v-model="selectedGivenStatus"  :options="givenOptions" placeholder="Select an option" class="p-column-filter w-full" :showClear="true" >
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="flex align-items-center">
                              <div>{{ slotProps.value.name }}</div>
                          </div>
                          <span v-else>
                              {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <Tag :value="getGivenValue(slotProps.option)" :severity="getGivenSeverity(slotProps.option)" />
                      </template>
                  </Dropdown>
                </div>
                <div class="field col">
                  <strong><label for="firstname2">Receive Status:</label></strong>
                  <Dropdown v-model="selectedReceivedStatus"  :options="receivedOptions" placeholder="Select an option" class="p-column-filter w-full" :showClear="true" >
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="flex align-items-center">
                              <div>{{ slotProps.value.name }}</div>
                          </div>
                          <span v-else>
                              {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <Tag :value="getRecdValue(slotProps.option)" :severity="getRecdSeverity(slotProps.option)" />
                      </template>
                  </Dropdown>
                </div>
                <div class="field col">
                  <strong><label for="firstname2">Billed Status:</label></strong>
                  <Dropdown v-model="selectedBilledStatus"  :options="billedOptions" placeholder="Select an option" class="p-column-filter w-full" :showClear="true" >
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="flex align-items-center">
                              <div>{{ slotProps.value.name }}</div>
                          </div>
                          <span v-else>
                              {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <Tag :value="getBilledValue(slotProps.option)" :severity="getBilledSeverity(slotProps.option)" />
                      </template>
                  </Dropdown>
                </div>
                <div class="field col">
                  <strong><label class="w-full">Filter:</label></strong>
                  <div class="flex w-full">
                    <div class="flex-initial flex align-items-center justify-content-center w-full">
                      <Button class="w-full mx-1 my-1" size="small" icon="pi pi-filter" severity="success" v-tooltip.top="'Filter'" raised @click="customFilter" ></Button>
                    </div>
                    <div class="flex-initial flex align-items-center justify-content-center w-full">
                      <Button class="w-full mx-1 my-1" size="small" icon="pi pi-filter-slash" severity="warning" v-tooltip.top="'Clear filter'" text raised @click="clearCustomFilter" ></Button>
                    </div>
                  </div>
                </div>
                <div class="field col">
                  <strong><label for="firstname2">Filtered Value:</label></strong>
                  <InputNumber v-model="filteredDcValue" placeholder="Total DC value" class="w-full" locale="en-IN" :minFractionDigits="2" :maxFractionDigits="2" variant="filled" prefix="&#x20B9;" readonly/>
                </div>
              </div>                            
        </template>
        </Card>                     

            <Card class="mt-4 mx-3 h-full"> 
                <template #header >
                  <div class="flex justify-content-between flex-wrap mx-4 mt-3">
                      <div class="flex align-items-center justify-content-center text-xl">
                          Delivery Challan
                      </div>
                      <div class="flex align-items-center justify-content-center">
                          <router-link to="/delivery-challan-bulk" rel="noopener">
                            <Button label="Bulk Item DC" size="small" severity="info"  raised ></Button>
                          </router-link>
                          <Button icon="pi pi-external-link" label="Export" size="small" text raised class="mx-2" @click="exportData($event)" v-tooltip.top="'Export CSV'" ></Button>
                          <InputText v-model="filterQuery" placeholder="Keyword Search" size="small" ></InputText>
                          <Button class="ml-2" icon="pi pi-filter" severity="success" raised size="small" @click="globalFilter" v-tooltip.top="'Search'" ></Button>
                          <Button class="ml-2" icon="pi pi-filter-slash" size="small" outlined raised severity="success" @click="clearFilter" v-tooltip.top="'Clear result'" ></Button> 
                      </div>
                  </div>
                </template>
                <template #content>

                <DataTable :value="filteredDcList" sortMode="multiple" ref="dcList" size="small" :loading="tableLoading" v-model:filters="filters" tableStyle="min-width: 50rem" v-model:expandedRows="expandedRows" dataKey="id" @rowExpand="onRowExpand" @rowCollapse="onRowCollapse" paginator :rows="50" :rowsPerPageOptions="[10, 20, 50, 100, 200]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="60vh">

                    <Column expander style="width: 5rem"/>
                    <Column field="dcNo" header="DC No.">
                      <template #body="slotProps">
                            <router-link @click="dcDoc(slotProps.data)" to="/dc-pdf" >{{slotProps.data.dcNo}}</router-link>
                        </template>
                    </Column>
                    <Column field="dcDate" header="DC Date">
                    </Column>
                    <Column field="dept.shortCode" header="Dept"/>
                    <Column field="deptPo" header="Dept PO"/>
                    
                    <Column field="location.name" header="Location"/>

                    <Column field="dcValue" header="Value">
                      <template #body="slotProps">
                        {{formatCurrency(slotProps.data.dcValue)}}
                      </template>
                    </Column>
                    
                    <Column header="Given">
                      <template #body="slotProps">
                        <Button v-if="slotProps.data.givenStatus==0" size="small" label="Give Out" icon="pi pi-sign-out" class="px-2 py-1" severity="danger" text raised @click="showGiveOutDialog(slotProps.data)"></Button>
                          <Tag v-if="slotProps.data.givenStatus==1" value="Given" severity="success" ></Tag>
                      </template>
                    </Column>
                    <Column header="Action">
                      <template #body="slotProps">
                        <div v-if="slotProps.data.recdStatus==0" class="flex">
                          <div class="flex-initial flex align-items-center justify-content-center">
                            <Button  icon="pi pi-file-edit" severity="success" size="small" rounded text @click="showEditChallanDialog(slotProps.data)" v-tooltip.top="'Edit DC date'" class="mr-1" ></Button>

                            <!-- <Button  icon="pi pi-file-edit" severity="success" raised rounded text @click="toggleEditdcDialog(slotProps.data)" v-tooltip.top="'Edit DC date'" class="mr-1"/> -->                            
                          </div>
                          <div class="flex-initial flex align-items-center justify-content-center">
                            <!-- <Button v-if="slotProps.index==0" icon="pi pi-trash" severity="danger"  raised rounded v-tooltip.top="'Delete DC'"/> -->
                            <Button icon="pi pi-times" severity="danger" size="small"  rounded text v-tooltip.top="'Cancel DC'" @click="showCancelDialog(slotProps.data)" ></Button>
                          </div>
                          <div class="flex-initial flex align-items-center justify-content-center">
                            
                                <!-- <router-link :to="{
                                    name: 'delivery-challan-update',
                                    params:{
                                        id:slotProps.data.id,
                                    }
                                }" target="_blank" rel="noopener">
                                  <Button icon="pi pi-plus" size="small" outlined rounded text v-tooltip.top="'Add Item'" />
                                </router-link> -->
                                <Button icon="pi pi-plus" size="small" outlined rounded text v-tooltip.top="'Add Item'" @click="toggleAddItemDcDialog(slotProps.data)"/>                            
                          </div>  
                        </div>

                        <div v-if="slotProps.data.recdStatus==1" class="flex">
                          <div class="flex-initial flex align-items-center justify-content-center">
                            <Button  icon="pi pi-file-edit" severity="success" rounded text disabled class="mr-1"/>
                          </div>
                          <div class="flex-initial flex align-items-center justify-content-center">
                            <Button  icon="pi pi-times" severity="danger" rounded text disabled />
                          </div>
                          <div class="flex-initial flex align-items-center justify-content-center">
                            <Button icon="pi pi-plus" size="small" outlined rounded text v-tooltip.top="'Add Item'" disabled/>
                          </div>
                        </div>
                      </template>
                    </Column>

                    <Column field="recdStatus" header="Recd">
                      <template #body="slotProps">
                        <Button v-if="slotProps.data.givenStatus==1 && slotProps.data.recdStatus==0" size="small" label="Update Recd" class="px-2 py-1" severity="help" raised text @click="showRecdDcDialog(slotProps.data)"></Button>
                            <Tag v-if="slotProps.data.givenStatus==0" :value="getStatusRecd(slotProps.data)" :severity="getSeverityRecd(slotProps.data)" />
                            <Tag v-if="slotProps.data.recdStatus==1" value="Received" severity="success" />                            
                        </template>
                    </Column>

                    <Column  header="Billed">
                      <template #body="slotProps">
                            <Tag v-if="slotProps.data.billStatus==0" value="Pending" severity="danger" />
                            <div class="billClass" v-if="slotProps.data.billStatus !=0">
                            <label  >{{slotProps.data.billStatus}}</label>
                            </div>
                        </template>
                    </Column>

                    <Column  header="Re-Location"> 
                      <template #body="slotProps">
                          <Tag v-if="slotProps.data.reLocated==1 || slotProps.data.reLocated==2" :value="getReLocationValue(slotProps.data.reLocated)" :severity="getReLocationSeverity(slotProps.data.reLocated)" ></Tag>
                      </template>
                    </Column>

                    <!-- for uploading signed delivery challan  -->
                    <!-- <Column header="Upload">
                      <template #body="slotProps">
                          <FileUpload v-if="slotProps.data.recdStatus==1" class="px-2 py-2" mode="basic" name="demo[]" url="/api/upload" accept="image/*" :maxFileSize="1000000" @upload="onDcUpload(slotProps.data)" />                          
                            <Tag v-if="slotProps.data.recdStatus==0" value="Update Recd" severity="danger" />
                        </template>
                    </Column> -->

                    <template #expansion="slotProps">
                      <DataTable :value="slotProps.data.dcItems" v-model:editingRows="editChildRow" editMode="row" dataKey="id" @row-edit-save="onChildRowEditSave($event, slotProps.data.id)" :pt="{
                table: { style: 'min-width: 25rem' },
                column: {
                    bodycell: ({ state }) => ({
                        style:  state['d_editing']&&'padding-top: 0.6rem; padding-bottom: 0.6rem;'
                    })
                }
                }" >
                        <Column field="name" header="Item"/>
                        <Column field="hsn" header="HSN"/>
                        <Column field="packing" header="Packing">
                          <template #body="slotProps">
                              {{ slotProps.data.packing }}
                          </template>
                          <template #editor="{ data, field }">
                              <InputText v-model="data[field]" />
                          </template>
                        </Column>
                        <Column field="qty" header="Quantity"/>
                        <Column field="modelNo" header="Model">
                          <template #body="slotProps">
                              {{ slotProps.data.modelNo }}
                          </template>
                          <template #editor="{ data, field }">
                              <InputText v-model="data[field]" />
                          </template>
                        </Column>
                        <Column field="partNo" header="Part/Sr No.">
                          <template #body="slotProps">
                              {{ slotProps.data.partNo }}
                          </template>
                          <template #editor="{ data, field }">
                              <InputText v-model="data[field]" />
                          </template>
                        </Column>
                        <Column field="batch_no" header="Batch">
                          <template #body="slotProps">
                              {{ slotProps.data.batch_no }}
                          </template>
                          <template #editor="{ data, field }">
                              <InputText v-model="data[field]" />
                          </template>
                        </Column>
                        <Column field="mfgDate" header="Mfg Date">
                          <template #body="slotProps">
                                {{ slotProps.data.mfgDate }}
                            </template>
                            <template #editor="{ data, field }">
                              <Calendar v-model="data[field]" class="w-full" dateFormat="dd-mm-yy"/>
                          </template>
                        </Column>
                        <Column field="expDate" header="Exp Date">
                          <template #body="slotProps">
                              {{slotProps.data.expDate}}
                          </template>
                          <template #editor="{ data, field }">
                              <Calendar v-model="data[field]" class="w-full" dateFormat="dd-mm-yy"/>
                          </template>
                        </Column>
                        <Column v-if="slotProps.data.recdStatus==0" header="Update" :rowEditor="true" style="width: 7%; min-width: 4rem" bodyStyle="text-align:center"></Column>
                        <Column v-if="slotProps.data.recdStatus==0 && slotProps.data.dcItems.length>1" header="Delete">                          
                          <template #body="slotProps">
                            <Button icon="pi pi-trash" severity="danger" raised v-tooltip.top="'Remove item'" @click="showDeleteDialog(slotProps.data)"/>
                          </template>
                        </Column>
                        <Column v-if="slotProps.data.recdStatus==1" header="Re-Locate" >
                          <template #body="slotProps">
                            <Button v-if="slotProps.data.reLocation!=1" class="ml-1" icon="pi pi-arrow-right-arrow-left" severity="help" raised v-tooltip.top="'Re-Locate'" @click="reLocateDialog(slotProps.data)" />

                            <Tag v-if="slotProps.data.reLocation==1" class="ml-1" severity="success" value="Re-Located" ></Tag>
                            
                            <Tag v-if="slotProps.data.reLocation==2" class="ml-1" severity="warning" value="Partially" ></Tag>

                          </template>
                        </Column>
                        <Column field="remark" header="Bill Update">
                          <template #body="slotProps">
                            
                            <Button v-if="slotProps.data.remark != null" label="Show" size="small" class="px-2 py-2" severity="success" @click="showDeliveredStockDialog($event, slotProps.data)"/>
                            <!-- <Tag v-if="slotProps.data.remark == null" severity="secondary" value="NA" /> -->
                            <Chip v-if="slotProps.data.remark == null" label="NA"  />
                          </template>
                        </Column>
                      </DataTable>
                    </template>

                  </DataTable>
                  <!-- update dc status -->
                    <Dialog :visible="giveOutDcDialogVisibility" modal :closable="false" header="Give out Delivery Challan?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">                        
                            <div class="flex">
                                <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-sign-out" style="font-size: 2.5rem"></i></div>
                                <div class="flex align-items-center justify-content-center ">
                                    <p> DC No.: <strong>{{dcNo}}</strong><br> Once given, Dept PO stock would be updated.</p>
                                </div>                              
                            </div>
                        <div class="flex justify-content-end flex-wrap">
                            <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Cancel" outlined severity="secondary" @click="giveOutDcDialogVisibility=false"></Button>
                            <Button class="my-1 py-2" label="Yes" severity="success" @click="updateGivenAndStock" />
                        </div>
                    </Dialog>
                    <!-- update dc status end -->

                    <!-- update recd dc -->
                    <Dialog :visible="recdDcDialogVisibility" modal :closable="false" header="Received Signed Delivery Challan?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">                        
                            <div class="flex">
                                <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-sign-in" style="font-size: 2.5rem"></i></div>
                                <div class="flex align-items-center justify-content-center ">
                                    <p> DC No.: <strong>{{dcNo}}</strong><br> Once received, Challan won't be editable.</p>
                                </div>                              
                            </div>
                        <div class="flex justify-content-end flex-wrap">
                            <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Cancel" outlined severity="secondary" @click="recdDcDialogVisibility=false"></Button>
                            <Button class="my-1 py-2" label="Yes" severity="success" @click="updateRecdChallan" />
                        </div>
                    </Dialog>
                    <!-- update recd dc end -->

                  <Dialog :visible="editDcDialogVisibility" modal :closable="false" :header="dialogHeader" :style="{ width: '45rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

                    <div class="field grid">
                        <label class="col-fixed" style="width:100px">DC No.:</label>
                          <div class="col">
                              <label>
                                <strong>
                                  <em>
                                    {{dc.dcNo}}
                                  </em>
                                </strong>
                              </label>
                          </div>
                      </div>

                    <div class="field grid">
                        <label class="col-fixed" style="width:100px">Department:</label>
                          <div class="col">
                              <label>
                                <strong>
                                  <em>
                                    {{dc.dept.name}}
                                  </em>
                                </strong>
                              </label>
                          </div>
                      </div>

                    <div class="field grid">
                        <label class="col-fixed" style="width:100px">Location:</label>
                          <div class="col">
                              <label>
                                <strong>
                                  <em>
                                    {{dc.location.name}}
                                  </em>
                                </strong>
                              </label>
                          </div>
                      </div>

                      <div class="field grid">
                        <label class="col-fixed" style="width:100px">DC Date:</label>
                          <div class="col">
                              <Calendar v-model="newdcDate" class="w-full" dateFormat="dd/mm/yy"/>
                          </div>
                      </div>
                                                        
                      <div class="flex justify-content-between flex-wrap">
                        <div class="flex align-items-center justify-content-center">
                          <label style="font-size:14px;">Note:<strong>DC No. would be updated to a new DC No.</strong></label>
                        </div>
                        <div class="flex align-items-center justify-content-center">
                          <Button class="flex align-items-center justify-content-center mx-1 px-2 my-1" size="small" label="Update" icon="pi pi-refresh" severity="success" @click="handleUpdateDc"></Button>
                          <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" outlined severity="secondary" @click="editDcDialogVisibility=false"></Button>
                        </div>
                      </div>
                  </Dialog>

                  <!-- cancel dc dialog statrt -->

                  <Dialog :visible="cancelDcDialogVisibility" modal :closable="false" header="Are you sure?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                        
                            <div class="flex">
                                <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
                                <div class="flex align-items-center justify-content-center ">
                                    <p> DC No.: <strong>{{dcNo}}</strong>
                                    <br>This will cancel the Delivery Challan!
                                    <br>Items would be revoked to previous state. </p>
                                </div>                              
                            </div>
                            <div class="formgrid grid">
                              <div class="field col">
                                <label >Remarks:</label>
                                <Textarea v-model="cancelRemark" rows="5" cols="45" />
                              </div>
                            </div>

                        <div class="flex justify-content-end flex-wrap">
                            <Button class="my-1 py-2 mr-2" label="Cancel DC" severity="danger" @click="cancelDeliveryChallan" />
                            <Button class="flex align-items-center justify-content-center my-1 " size="small" label="Close" outlined severity="secondary" @click="cancelDcDialogVisibility=false"></Button>
                        </div>
                    </Dialog>
                    <!-- cancel dc dialog end -->

                            <OverlayPanel  ref="itemRemarkOp" dismissable>
                                    <h4> <label class="text-cyan-500">Updated when billed :</label> {{updatedItemName}}</h4>

                                    <table width="350px;">
                                      <tr>
                                        <th>
                                          Prev Qty:
                                        </th>
                                        <td>
                                          <label class="text-orange-500">{{itemPrevQty}}</label>
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>
                                          Remarks:
                                        </th>
                                        <td>
                                          <label >{{dcRemark}}</label>
                                        </td>
                                      </tr>
                                    </table>
                            </OverlayPanel>

                    <Dialog :visible="dcAddItemDialog" modal :closable="false" :header="dcEditDialogHeader" :style="{ width: '80rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

                      <div class="formgrid grid">
                          <div class="field col">
                              <label class="text-base font-medium" >DC No.:</label>
                              <InputText class="w-full" v-model="itemDcNo" readonly />   
                          </div>
                          <div class="field col">
                              <label class="text-base font-medium" >DC Date:</label>
                              <InputText class="w-full" v-model="itemDcDate" readonly />
                          </div>
                      </div>
                      <div class="formgrid grid">
                          <div class="field col">
                              <label class="text-base font-medium" >PO No.:</label>
                              <InputText class="w-full" v-model="itemPoNo" readonly />   
                          </div>
                          <div class="field col">
                              <label class="text-base font-medium">Location:</label>
                              <InputText class="w-full" v-model="itemDcLocation.name" readonly />
                          </div>
                      </div>

                      <hr class="hr-style">
                      <div>
                        <label class="text-base">Items present:</label>
                      </div>

                      <div class="mt-2">
                        <DataTable :value="challanItems" stripedRows showGridlines  size="small" scrollable scrollHeight="200px" >
                          <Column header="Sl No.">
                              <template #body="slotProps">
                                  {{ ++slotProps.index }}
                              </template>
                          </Column>
                          <Column field="name" header="Item"/>
                          <Column field="hsn" header="HSN"/>
                          <Column field="packing" header="Packing">
                            <template #body="slotProps">
                                {{ slotProps.data.packing }}
                            </template>
                          </Column>
                          <Column field="qty" header="Quantity"/>
                          <Column field="modelNo" header="Model">
                            <template #body="slotProps">
                                {{ slotProps.data.modelNo }}
                            </template>
                          </Column>
                          <Column field="partNo" header="Part/Sr No.">
                            <template #body="slotProps">
                                {{ slotProps.data.partNo }}
                            </template>
                          </Column>
                          <Column field="batch_no" header="Batch">
                            <template #body="slotProps">
                                {{ slotProps.data.batch_no }}
                            </template>
                          </Column>
                          <Column field="mfgDate" header="Mfg Date">
                            <template #body="slotProps">
                                  {{ slotProps.data.mfgDate }}
                              </template>
                          </Column>
                          <Column field="expDate" header="Exp Date">
                            <template #body="slotProps">
                                {{slotProps.data.expDate}}
                            </template>
                          </Column>
                        </DataTable>
                      </div>

                      <hr class="hr-style mt-5">

                      <div class="grid">
                          <div class="col-8 mt-2">
                              
                                <label class="text-base">Add items here:</label>
                                <ScrollPanel style="width:100%; height:20vh" class="mb-6" >
                                    <div v-if="dcNewItems.length == 0" class="mx-3 mt-3">
                                        <span >Please select items from the available stock to be added to Delivery Challan.</span>
                                    </div>
                                    <DcItem v-for="(item, index) in dcNewItems" :key="index" :sl="index+1" :item="item" @bind-item="bindData" class="mx-3 mt-3"/>
                                </ScrollPanel>
                              
                          </div>
                          <div class="col-4 mt-2">
                              <div >
                                <label class="text-base">Available in Stock:</label>
                                <DataTable class="mt-3" :value="itemsInStock" v-model:selection="selectedNewItems" @row-select="addItemsToDc" @row-unselect="removeItemDc" :loading="loading2" stripedRows showGridlines size="small" scrollable scrollHeight="200px">

                                  <template #empty>
                                      <div class="flex ">
                                          <div class="flex-initial flex justify-content-center w-full"> 
                                              <label class="font-medium" >No stock available</label>
                                          </div>
                                      </div>
                                  </template>
                                  
                                  <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                                    <Column field="name" header="Item" >
                                        <template #body="slotProps">
                                            <label class="text-sm">
                                                {{slotProps.data.name}}
                                            </label>
                                        </template>
                                    </Column>
                                    <Column field="quantity" header="Qty">
                                        <template #body="slotProps">
                                            <label class="text-sm">
                                                {{slotProps.data.quantity}}
                                            </label>
                                        </template>
                                    </Column>                                    
                                    <Column header="To deliver">
                                        <template #body="slotProps">
                                          {{slotProps.data.toDeliver}}
                                        </template>
                                    </Column>
                                    <Column header="Delivered">
                                        <template #body="slotProps">
                                          {{slotProps.data.deliveredQty}}
                                        </template>
                                    </Column>
                                    <Column header="Pending">
                                        <template #body="slotProps">
                                          {{slotProps.data.pendingDelivery}}
                                        </template>
                                    </Column>                                 

                                </DataTable>
                              </div>
                          </div>
                      </div>

                      <template #footer>
                        <hr class="hr-style">
                        <div class="flex justify-content-end flex-wrap">
                            <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Update Challan" severity="success" raised @click="handleSaveNewChallanItems" ></Button>
                            <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="danger" text raised @click="toggleAddItemDcDialog(null)"></Button>
                        </div>
                      </template>
                    </Dialog>
                </template>                
            </Card>
        <!-- </div> -->
        <Dialog :visible="deleteItemDialogVisibility" modal :closable="false" :header="deleteItemHeader" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

          <div class="flex">
              <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
              <div class="flex align-items-center justify-content-center ">
                  <p>Item will be removed from delivery challan. <br> Are you sure you want to remove the item?</p>
              </div>
          </div> 

          <template #footer>
            <div class="flex justify-content-end flex-wrap">
              <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Delete" severity="danger" raised @click="deleteItem"></Button>
              <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="secondary" text raised @click="deleteItemDialogVisibility=false"></Button>
            </div>
          </template>

        </Dialog>

        <Dialog :visible="reLocateDialogVisibility" modal :closable="false" :header="reLocateDialogHeader" :style="{ width: '80rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <div class="grid">
                <div class="col ">
                    <label class="font-medium">Quantity:</label>
                    <InputNumber v-model="challanItem.qty" class="w-full" disabled/>
                </div>
                <div class="col-3">
                    <label class="font-medium">Batch:</label>
                    <InputText v-model="challanItem.batch_no" class="w-full" disabled/>
                </div>
                <div class="col-3">
                    <label class="font-medium">Model:</label>
                    <InputText v-model="challanItem.modelNo" class="w-full" disabled/>
                </div>
                <div class="col-3">
                    <label class="font-medium">Part:</label>
                    <InputText v-model="challanItem.partNo" class="w-full" disabled/>
                </div>
                <div class="col-3">
                    <label class="font-medium">New Location:</label>
                        <Dropdown v-model="newLocation" :options="dbLocations" optionLabel="name" optionValue="id" class="w-full" filter placeholder="Select new location"/>
                </div>
                <div class="col">
                    <label class="font-medium">Re-Locate Quantity:</label>
                    <InputNumber v-model="newQuantity" class="w-full" />
                </div>
                <div class="col">
                    <label class="font-medium">Remarks:</label>
                    <InputText v-model="reLocateRemarks" class="w-full" placeholder="Reason for Re-location" />
                </div>
            </div>

              <template #footer>
                <div class="flex justify-content-end flex-wrap">
                  <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Re-Locate" v-tooltip.top="'Delete and Update Location'" severity="help" raised @click="handleReLocation"></Button>

                  <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="secondary" text raised @click="reLocateDialogVisibility=false"></Button>
                </div>
              </template>
          </Dialog>

</div>
</div>

</template>

<script>
import ProgressSpinner from 'primevue/progressspinner'
import Card from 'primevue/card'
// import Navbar from '../header/headerNavbar.vue'
import Column from 'primevue/column'
import { addItemsDeliveryChallan, cancelDc, deleteChallanItem, getDeliveryChallan, getItemsPendingDelivery, updateDc, updateDcStatusAndStock, updateGivenDc, updateRecdDc, getDeliveryLocations, reLocateAfterChallan } from '@/services/apiService'
import { FilterMatchMode } from 'primevue/api'
import DataTable from 'primevue/datatable'
import { useDcStore } from '@/stores/dcStore';
import Tag from 'primevue/tag'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Calendar from 'primevue/calendar'
import OverlayPanel from 'primevue/overlaypanel'
import Chip from 'primevue/chip'
import Textarea from 'primevue/textarea'
import { useBillStore } from '@/stores/billStore'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
// import FileUpload from 'primevue/fileupload'
// import SideBar from '../sidebar/sideBarTwo.vue'
import ScrollPanel from 'primevue/scrollpanel'
import DcItem from '../deliveryChallan/deliveryChallanItem.vue'

export default {
  components:{
    // Navbar,
    // SideBar,
      ProgressSpinner,
      Card,
      Column,
      DataTable,
      Tag,
      InputText,
      Button,
      Dialog,
      Calendar,
      OverlayPanel,
      Chip,
      // FileUpload,
      Textarea,
      Dropdown,
      InputNumber,
      ScrollPanel,
      DcItem,
    },

    data(){
      return{
        expandedRows:[],
        spinnerLoadingStatus:false,
        dcList:[],
        filterQuery:null,
        filteredDcList:[],
        filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dcNo: { value: null, matchMode: FilterMatchMode.IN },
                'dept.name':{ value: null, matchMode: FilterMatchMode.IN },
                billStatus: { value: null, matchMode: FilterMatchMode.IN },
            },
        editParentRow:[],
        editDcDialogVisibility:false,
        dc:null,
        dcNo:null,
        newdcDate:null,
        giveOutDcDialogVisibility:false,
        tableLoading:false,
        pagination:null,
        firstRecord:null,
        lastRecord:null,
        totalRecord:null,
        perPageRecord:10,
        recdDcDialogVisibility:false,
        dcRemark:null,
        itemPrevQty:0,
        updatedItemName:null,
        cancelDcDialogVisibility:false,
        cancelRemark:null,
        editChildRow:null,
        selectedGivenStatus:null,
        selectedReceivedStatus:null,
        selectedBilledStatus:null,
        selectedDateRange:null,
        givenOptions:[
          {id:'1', name:'Given', icon:'pi pi-sign-out'}, 
          {id:'0', name:'Pending', icon:'pi pi-clock'}
        ],
        receivedOptions:[
          {id:'1', name:'Received'}, 
          {id:'0', name:'Not Received'}
        ],
        billedOptions:[
          {id:'1', name:'Billed'}, 
          {id:'0', name:'Pending Billing'}
        ],
        filteredDcValue:0.0,
        dcAddItemDialog:false,
        dcEditDialogHeader:null,
        dcId:null,
        itemDcNo:null,
        itemDcDate:null,
        itemPoNo:null,
        itemDcLocation:null,
        challanItems:[],
        itemsInStock:[],
        selectedNewItems:null,
        loading2:false,
        dcNewItems:[],
        tempDcData:null,
        deleteItemDialogVisibility:false,
        deleteItemHeader:null,
        itemToDelete:null,
        reLocateDialogVisibility:false,
        reLocateDialogHeader:null,
        challanItem:null,
        dbLocations:[],
        newLocation:null,
        newQuantity:0,
        reLocateRemarks:null,
      }
    },

    methods:{
      getDcList(){
        this.tableLoading = true;
        const query = '?cancel[eq]=0&reLocation[eq]=0'
        getDeliveryChallan(query).then((res)=>{
          this.dcList = res.data;
          this.filteredDcList = [];
          this.dcList.forEach(e => {
            let dcAmt = 0;
            e.dcItems.forEach(l => {
              dcAmt += (l.deptRate * l.qty) + (((l.deptRate * l.qty)/100)*l.gstRate);
            });
            this.filteredDcList.push({
              ...e,
              dcValue:dcAmt,
            });
            
          });
          this.dcList = this.filteredDcList;
          this.tableLoading = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.tableLoading = false;
        });
      },
      getLocations(){
          getDeliveryLocations().then((res)=> 
              {
                  this.dbLocations = res.data
              }
              ).catch((error)=>this.showErrorToast(error.response.data));
      },
      dcDoc(data){
            const store = useDcStore(); 
            store.$patch({
                data:data,
            })
      },
      showGiveOutDialog(data){
        this.giveOutDcDialogVisibility = true;
        this.dc = data;
        this.dcNo = data.dcNo;
      },
      showRecdDcDialog(data){
        this.recdDcDialogVisibility = true;
        this.dc = data;
        this.dcNo = data.dcNo;
      },
      updateGivenAndStock(){
        const data = {
          'dcId':this.dc.id,
          'dcItems':this.dc.dcItems,
          'location':this.dc.location,
        }
        
        this.giveOutDcDialogVisibility = false;
        this.spinnerLoadingStatus = true;

        updateDcStatusAndStock(data).then((res)=>{
          this.showSuccessToast(res.data);
          this.dc = null;
          this.getDcList();
          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
          this.dc = null;
        })
      },
      updateRecdChallan(){
        this.recdDcDialogVisibility = false;
        this.spinnerLoadingStatus = true;
        updateRecdDc({id:this.dc.id}).then((res)=>{
          this.showSuccessToast(res.data);
          this.spinnerLoadingStatus = false;
          this.getDcList();
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
      },
      showEditChallanDialog(dcData){
        this.dc = dcData;
        this.newdcDate = dcData.dcDate;
        this.editDcDialogVisibility = true;
      },
      handleUpdateDc(){
        if(this.dc.dcDate==this.newdcDate){
          this.editDcDialogVisibility = false;
          return;
        }
        const data = {
          'dcDate':this.newdcDate.getFullYear()+'-'+(this.newdcDate.getMonth()+1)+'-'+this.newdcDate.getDate(), 
        }

        this.editDcDialogVisibility = false;

        this.spinnerLoadingStatus = true;

        updateGivenDc(data, this.dc.id).then((res)=>{
          this.showSuccessToast(res.data);
          this.spinnerLoadingStatus = false;
          this.getDcList();
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
      },
      onDcUpload(data){
        console.log('upload doc');
        console.log(data);
      },
      showCancelDialog(data){
        this.cancelDcDialogVisibility = true;
        this.dc = data;
        this.dcNo = data.dcNo;
        this.cancelRemark = null;
      },
      cancelDeliveryChallan(){
        const data = {
          'dcId':this.dc.id,
          'location':this.dc.location.locationId,
          'dcNo':this.dc.dcNo,
          'dcItems':this.dc.dcItems,
          'givenStatus':this.dc.givenStatus,
          'remarks':this.cancelRemark,
          'deptId':this.dc.dept.id,
        }

        this.cancelDcDialogVisibility = false;

        this.spinnerLoadingStatus = true;

        cancelDc(data).then((res)=>{
          this.showSuccessToast(res.data);
          this.getDcList();
          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })

      },
      showDeliveredStockDialog(event, data){
          this.updatedItemName = data.name;
          this.dcRemark = data.remark;
          this.itemPrevQty = data.prevQty;
          this.$refs.itemRemarkOp.toggle(event);
      },
      onChildRowEditSave(event, dcId){
        
        let mfgDate = null;
        if(event.newData.mfgDate!=null && typeof(event.newData.mfgDate)=="string"){
          mfgDate = event.newData.mfgDate.split("-")
          mfgDate = mfgDate[2]+'-'+mfgDate[1]+'-'+mfgDate[0]
        }

        if(event.newData.mfgDate!=null && typeof(event.newData.mfgDate)=="object"){
          mfgDate = event.newData.mfgDate.getFullYear()+'-'+(event.newData.mfgDate.getMonth()+1)+'-'+event.newData.mfgDate.getDate()
        }
        
        let expDate = null;
        if(event.newData.expDate!=null && typeof(event.newData.expDate)=="string"){
          expDate = event.newData.expDate.split("-")
          expDate = expDate[2]+'-'+expDate[1]+'-'+expDate[0]
        }

        if(event.newData.expDate!=null && typeof(event.newData.expDate)=="object"){
          expDate = event.newData.expDate.getFullYear()+'-'+(event.newData.expDate.getMonth()+1)+'-'+event.newData.expDate.getDate()
        }                
        
            const data = {
                'dcId':dcId,
                'id':event.data.id,
                'oldPacking':event.data.packing,
                'oldBatch':event.data.batch_no,
                'oldModelNo':event.data.modelNo,
                'oldPartNo':event.data.partNo,
                'oldMfgDate':event.data.mfgDate,
                'oldExpDate':event.data.expDate,
                'newPacking':event.newData.packing,
                'newBatch':event.newData.batch_no,
                'newModelNo':event.newData.modelNo,
                'newPartNo':event.newData.partNo,
                'newMfgDate':mfgDate,
                'newExpDate':expDate,
            }

            this.spinnerLoadingStatus = true;
            updateDc(data).then((res)=>{
                this.showSuccessToast(res.data);
                this.spinnerLoadingStatus = false;
                this.getDcList();
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.spinnerLoadingStatus = false;
            });
      },
      getStatus(data){
            switch (data.givenStatus) {
                case '1':
                    return 'Given'
                case '0':
                    return 'Not Given';
                default:
                    break;
            }
      },
      getSeverity(data){
          switch (data.givenStatus) {
              case '1':
                  return 'success'
              case '0':
                  return 'danger';
              default:
                  break;
          }
      },
      getStatusRecd(data){
          switch (data.recdStatus) {
              case '1':
                  return 'Received'
              case '0':
                  return 'Not Received';
              default:
                  break;
          }
      },
      getSeverityRecd(data){
          switch (data.recdStatus) {
              case '1':
                  return 'success'
              case '0':
                  return 'danger';
              default:
                  break;
          }
      },
      getGivenValue(data){
        switch (data.id) {
                case '1':
                    return 'Given'
                case '0':
                    return 'Pending';
                default:
                    break;
            }
      },
      getGivenSeverity(data){
        switch (data.id) {
                case '1':
                    return 'success'
                case '0':
                    return 'danger';
                default:
                    break;
            }
      },
      getRecdValue(data){
        switch (data.id) {
                case '1':
                    return 'Received'
                case '0':
                    return 'Not Received';
                default:
                    break;
            }
      },
      getRecdSeverity(data){
          switch (data.id) {
                case '1':
                    return 'success'
                case '0':
                    return 'danger';
                default:
                    break;
            }
      },
      getBilledValue(data){
        switch (data.id) {
                case '1':
                    return 'Billed'
                case '0':
                    return 'Pending Billing';
                default:
                    break;
            }
      },
      getBilledSeverity(data){
          switch (data.id) {
                case '1':
                    return 'success'
                case '0':
                    return 'danger';
                default:
                    break;
            }
      },
      getReLocationValue(status){
        switch (status) {
          case '1':
              return 'Re-Located'
          case '0':
              return 'Not Re-Located';
          case '2':
              return 'Partially';
          default:
              break;
        }
      },
      getReLocationSeverity(status){
        switch (status) {
          case '1':
              return 'success'
          case '0':
              return 'help';
          case '2':
              return 'warning';
          default:
              break;
        }
      },
      showErrorToast(error){
          this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
      },
      showSuccessToast(data){
          this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
      },
      billDoc(data){
            const store = useBillStore();
            store.$patch({
                data:data,
            })
      },
      globalFilter(){
            
            this.filteredDcList = [];
            const condition = new RegExp(this.filterQuery, 'giv')
            if(this.filterQuery!=null){
                this.dcList.forEach(e => {     
                    if (e.dcNo.match(condition) || e.deptPo.match(condition) || e.dept.name.match(condition) || e.location.name.match(condition) || e.billStatus.match(condition)) { 
                      this.filteredDcList.push(e); 
                    }
                    else{
                        e.dcItems.every(el => { 
                            if(el.name.match(condition) || (el.batch_no ? el.batch_no.match(condition) : false ) || (el.partNo ? el.partNo.match(condition) : false) || (el.modelNo ? el.modelNo.match(condition) : false)){
                                this.filteredDcList.push(e);
                                return false;
                            }
                            return true;
                        });
                    }
                });
            }
      },
      clearFilter(){
          this.filteredDcList = this.dcList;
          this.filterQuery = null;
      },
      customFilter(){
        let temp = this.dcList; 
        this.filteredDcList = [];
        this.filteredDcValue = 0;
        if(this.selectedGivenStatus || this.selectedBilledStatus || this.selectedBilledStatus){
          temp.forEach(e => {
            let dcAmt = 0;
             if((this.selectedGivenStatus ? e.givenStatus==this.selectedGivenStatus.id : true) && (this.selectedReceivedStatus ? e.recdStatus==this.selectedReceivedStatus.id : true) && (this.selectedBilledStatus ? ((this.selectedBilledStatus.id==1 && e.billStatus!=0) || (this.selectedBilledStatus.id==0 && e.billStatus==this.selectedBilledStatus.id)) : true)){
               e.dcItems.forEach(l => {
                 this.filteredDcValue += (l.deptRate * l.qty) + (((l.deptRate * l.qty)/100)*l.gstRate);
                 dcAmt += (l.deptRate * l.qty) + (((l.deptRate * l.qty)/100)*l.gstRate);

              });

                this.filteredDcList.push({
                  ...e,
                  dcValue:dcAmt,
                  });
             }
          });
        }
      },
      clearCustomFilter(){
        this.selectedGivenStatus = null;
        this.selectedReceivedStatus = null;
        this.selectedBilledStatus = null;
        this.selectedDateRange = null;
        this.filteredDcValue = 0;
        this.filteredDcList = this.dcList; 
      },
      toggleAddItemDcDialog(data){          
          if(this.dcAddItemDialog==false){
            this.tempDcData = data
              this.dcId = data.id
              this.itemDcNo = data.dcNo
              this.itemDcDate = data.dcDate
              this.itemPoNo = data.deptPo
              this.itemDcLocation = data.location  
              this.challanItems = [...data.dcItems]
              const query = 'poId[eq]='+data.deptPoId

              this.loading2 = true
              this.itemsInStock = []

              getItemsPendingDelivery(query).then((res)=>{
                res.data.forEach(e => {
                  e.location.every(l => {                         
                      if(l.locationId==this.itemDcLocation.locationId && (l.deliveredQty < l.quantity)){
                          this.itemsInStock.push({
                            ...e,
                            deliveredQty:l.deliveredQty,
                            toDeliver:l.quantity,
                            pendingDelivery:(l.quantity-l.deliveredQty),
                          })
                          return false;
                      }
                      return true;
                  });
                  
                });
                this.loading2 = false
                
              }).catch((error)=>{
               this.showErrorToast(error.response.data);
                this.loading2 = false
              })

              this.dcEditDialogHeader = "Add Item to Challan:"
              this.dcAddItemDialog = true              
              return
          }

          if(this.dcAddItemDialog==true){
              this.dcNewItems = []
              this.itemDcNo = null
              this.itemDcDate = null
              this.itemPoNo = null
              this.itemDcLocation = null
              this.selectedNewItems = []
              this.dcAddItemDialog = false
              return
          }
      },
      addItemsToDc(event){
          const data = event.data

          this.dcNewItems.push({
              ...data,
              availableQty:data.quantity,
              avalQty:data.quantity,
              totalQty:data.quantity,
          });
      },
      bindData(itemId, itemData){
          const item = this.dcNewItems.find((e) => e.id == itemId);
          item.packing = itemData.itemUom;
          item.batchNo = itemData.itemBatch;
          item.partNo = itemData.itemPart;
          item.modelNo =itemData.itemModel;
          item.availableQty = itemData.itemQuantity;
          item.avalQty = itemData.itemAvailQty;
      },
      removeItemDc(event){
          const index = this.dcNewItems.findIndex((e)=>e.id ==event.data.id);
          this.dcNewItems.splice(index, 1);
      },
      handleSaveNewChallanItems(){
        
        const data = {
          'dcId':this.tempDcData.id,
          // 'location':this.tempDcData.location.id,
          'given':this.tempDcData.givenStatus,
          'dept':this.tempDcData.dept.id,
          'dcDate':this.tempDcData.dcDate,
          'deliveryLocation':this.tempDcData.location.locationId,
          'deptPo':this.tempDcData.deptPoId,
          'dcItems':this.dcNewItems,
        }

          this.toggleAddItemDcDialog(null)
          
          this.spinnerLoadingStatus = true
          addItemsDeliveryChallan(this.dcId, data).then((res)=>{
            this.showSuccessToast(res.data)
            this.spinnerLoadingStatus = false
            this.getDcList()
          }).catch((error)=>{
            this.showErrorToast(error.response.data)
            this.spinnerLoadingStatus = false
          })
      },
      showDeleteDialog(data){ 
        this.itemToDelete = data
        this.deleteItemHeader = 'Delete: '+data.name
        this.deleteItemDialogVisibility = true
      },
      deleteItem(){
        this.closeDeleteDialog()
        this.spinnerLoadingStatus = true;
        deleteChallanItem(this.itemToDelete.id).then((res)=>{
          this.itemToDelete = null;
          this.showSuccessToast(res.data);
          this.spinnerLoadingStatus = false;
          this.getDcList();     
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
        
      },
      reLocateDialog(item){
        this.reLocateDialogVisibility = true;
        this.challanItem = item;
        this.reLocateDialogHeader = 'Re-Locate: '+item.name;

      },
      handleReLocation(){
        if(this.newLocation==null){
          return this.showErrorToast({message:'Please select new location'});
        }
        if(this.newQuantity==0 || (this.newQuantity>0 && this.newQuantity>this.challanItem.qty)){
          return this.showErrorToast({message:'Invalid quantity!'});
        }

        const data = {
          itemId:this.challanItem.poItemId,
          dcItemId:this.challanItem.id,
          newLocation:this.newLocation,
          newQuantity:this.newQuantity,
          // oldLocationId
          oldQuantity:this.challanItem.qty,
          remarks:this.reLocateRemarks,
        }

        this.reLocateDialogVisibility = false;
        this.spinnerLoadingStatus = true;
        reLocateAfterChallan(data).then((res)=>{
          this.showSuccessToast(res.data);
          this.spinnerLoadingStatus = false;
          this.getDcList();
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
        
      },
      closeDeleteDialog(){
        this.deleteItemDialogVisibility = false
        this.deleteItemHeader = null
      },
      formatCurrency(value) {
        if(value)
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      },
      exportData(){
        this.$refs.dcList.exportCSV();
      }
    },

    mounted(){
      this.getDcList(); 
      this.getLocations();    
    }
}
</script>

<style scoped>

.progress-spinner {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.progress-spinner:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.53);
}

.billClass {
  border-radius: 10px;
  background-color: rgb(216, 210, 210);
  padding: 2px 5px;
  font-size: 11px;
  width: 120px;
}

hr.hr-style{
    border-top: 1px dashed #d5d8dc;
}

</style>